import { create } from "zustand";

type GuestType = "yes" | "no";

interface ModalStore {
  showCustomerModal: boolean;
  setShowCustomerModal: (value: boolean) => void;
  eguestType: GuestType;
  setEGuestType: (type: GuestType) => void;
  accountNumber: string;
  setAccountNumber: (val: string) => void;
  error: string;
  setError: (err: string) => void;
  reset: () => void;
  isLoading: boolean;
  setIsLoading: (val: boolean) => void;
  userExists: boolean;
  setUserExists: (val: boolean) => void;
}

export const useModalStore = create<ModalStore>((set) => ({
  showCustomerModal: false,
  eguestType: "no",
  accountNumber: "",
  error: "",
  isLoading: false,
  setIsLoading: (val) => set({ isLoading: val }),
  setShowCustomerModal: (value) => set({ showCustomerModal: value }),
  setEGuestType: (type) => set({ eguestType: type }),
  setAccountNumber: (val) => set({ accountNumber: val }),
  setError: (err) => set({ error: err }),
  reset: () =>
    set({
      showCustomerModal: false,
      eguestType: "no",
      accountNumber: "",
      error: "",
    }),

  userExists: false,
  setUserExists: (val) => set({ userExists: val }),
}));
